module.exports = __webpack_public_path__ + "static/media/prop-5-thumb.98e81e97.webp";